<!-- =========================================================================================
    File Name: TableSingleSelected.vue
    Description: Add functionality on selecting row
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="onResetFilter">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">브랜드명</label>
          <v-select :options="brandList" :clearable="false" v-model="brandName" name="item-brandName" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">코스명</label>
          <v-select :options="courseList" :clearable="false" v-model="courseName" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">레벨</label>
          <v-select :options="levelList" :clearable="false" v-model="level" class="mb-4 md:mb-0" />
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div>
        <div class="vx-col w-full">
          <div class="mb-4 flex flex-wrap justify-between">
            <div class="mb-4 flex flex-wrap">
              <vs-input class="sm:mr-4" v-model="serverParams.keyword" @keyup.enter="onSearch" placeholder="교재명" />
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-search" @click="onSearch"></vs-button>
            </div>
            <div class="justify-end">
              <vs-button class="" @click="onAdd">교재추가</vs-button>
            </div>
          </div>
        </div>

        <vue-good-table
          mode="remote"
          isLoading.sync="isLoading"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          @on-row-click="onRowClick"
          :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: '',
            perPage: 20
          }"
          :sort-options="{
            enabled: true,
            //initialSortBy: {field: 'bookName', type: 'asc'}
          }"
          :columns="columns"
          :rows="rows"
          :totalRows="totalRecords"
          :fix-header="true"
          :line-numbers="false"
          styleClass="vgt-table condensed"
          />
      </div>
    </vx-card> 
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { fetchData } from '@/api/module'
import vSelect from 'vue-select'

const defaultBrand = {label: '[브랜드명]', value: ''}
const defaultCourse = {label: '[코스명]', value: ''}
const defaultLevel = {label: '[레벨]', value: ''}

export default {
  components: {
    VueGoodTable,
    vSelect
  },
  watch: {
    brandName () {
      this.courseList = [defaultCourse]
      this.levelList = [defaultLevel]
      this.courseName = defaultCourse
      this.level = defaultLevel
      this.loadCourseList()
      this.loadItems()
    },
    courseName () {
      this.levelList = [defaultLevel]
      this.level = defaultLevel
      this.loadLevelList()
      this.loadItems()
    },
    level () {
      this.loadItems()
    }
  },   
  data () {
    return {
      isLoading: false,
      book_data: null,
      brandList: [defaultBrand],
      courseList: [defaultCourse],
      levelList: [defaultLevel],
      brandName: defaultBrand,
      courseName: defaultCourse,
      level: defaultLevel,
      columns: [
        {
          label: 'No.',
          field: 'bookSeq',
          type: 'name',
          sortable: false
        },
        {
          label: '브랜드',
          field: 'brandName',
          type: 'name',
          sortable: false
        },
        {
          label: '코스',
          field: 'courseName',
          type: 'name',
          sortable: false
        },
        {
          label: '레벨',
          field: 'levelName',
          type: 'name',
          sortable: false
        },
        {
          label: '교재명',
          field: 'bookName',
          type: 'name',
          sortable: false
        },
        {
          label: '권',
          field: 'volumeNumber',
          type: 'name',
          sortable: false
        },
        {
          label: '교재코드',
          field: 'bookCode',
          type: 'name',
          sortable: false
        },
        {
          label: '판매가',
          field: 'price',
          formatFn: this.price,
          type: 'name',
          sortable: false
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 20,
        field: 'BookSeq',
        type: 'ASC'
      }
    }
  },
  methods: {
    onResetFilter () {
      this.brandName = defaultBrand
      this.courseName = defaultCourse
      this.level = defaultLevel
      this.$refs.filterCard.removeRefreshAnimation()
    },
    price (value) {
      return `${String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')  }원`
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },
    onAdd () {
      this.$router.push('/book/book-add')
    },
    onRowClick (params) {
      // console.log(`onRowClick: ${JSON.stringify(params)}`);
      const bookSeq = params.row.bookSeq
      this.$router.push(`/book/book-view/${bookSeq}`)
    },

    onPageChange (params) {
      // console.log(`onPageChange: ${JSON.stringify(params)}`);
      this.serverParams.page = params.currentPage
      this.loadItems()
    },

    onPerPageChange (params) {
      // console.log(`onPerPageChange: ${JSON.stringify(params)}`);
      this.serverParams.perPage = params.currentPerPage
      this.serverParams.page = 1
      this.loadItems()
    },

    onSortChange (params) {
      // console.log(`onSortChange: ${JSON.stringify(params)}`);
      this.serverParams.field = params[0].field
      this.serverParams.type = params[0].type
      this.loadItems()
    },

    onSearch () {
      this.serverParams.page = 1
      this.loadItems()
    },

    onCourseChanged () {
      this.levelList = [defaultLevel]
      this.level = defaultLevel
      this.loadLevelList()
      this.loadItems()
    },
    onLevelChanged () {
      this.loadItems()
    },
    // load items is what brings back the rows from server
    async loadItems () { 
      try {
        
        this.serverParams = Object.assign(this.serverParams, {brandName: this.brandName.value})
        this.serverParams = Object.assign(this.serverParams, {courseName: this.courseName.value})
        this.serverParams = Object.assign(this.serverParams, {level: this.level.value})
        
        // console.log(`serverParams: ${JSON.stringify(this.serverParams)}`)

        const { data } = await fetchData('book', this.serverParams)
        this.$vs.loading.close()
        this.totalRecords = data.count
        this.rows = data.list 
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    },
    async loadBrandList () { 

      try {
        const { data } = await fetchData('brand')
        data.list.splice(0, 0, defaultBrand)
        this.brandList = data.list
      } catch (error) {
        
        console.log(error)

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    },
    async loadCourseList () { 

      try {
        const { data } = await fetchData('course', {brandName: this.brandName.value})
        data.list.splice(0, 0, defaultCourse)
        this.courseList = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    },
    async loadLevelList () { 

      try {
        const { data } = await fetchData('level', {brandName: this.brandName.value, courseName: this.courseName.value})
        data.list.splice(0, 0, defaultLevel)
        this.levelList = data.list
      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    }
  },
  created () {
    this.loadItems()
    this.loadBrandList()
  }
}
</script>
